// extracted by mini-css-extract-plugin
export default {"recipesNumber":"recipesNumber--4927b2c"};